// AWS Configuration - Uses environment variables
// Amplify v6 configuration format

// Debug environment variables
console.log('Environment variables loaded:', {
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
  USER_POOL_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
  OAUTH_DOMAIN: process.env.REACT_APP_OAUTH_DOMAIN,
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT
});

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_8TgdIatw1',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '7d09t96rk968984igl82fq0p8u',
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || 'us-east-1:d202532d-f045-406f-9605-fd9cb41f7e1a',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_OAUTH_DOMAIN || 'short-story-platform-dev-hv0xewkm.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            process.env.REACT_APP_REDIRECT_SIGN_IN || 'http://localhost:3000/callback'
          ],
          redirectSignOut: [
            process.env.REACT_APP_REDIRECT_SIGN_OUT || 'http://localhost:3000/'
          ],
          responseType: 'code'
        }
      }
    }
  },
  API: {
    REST: {
      'api': {
        endpoint: process.env.REACT_APP_API_ENDPOINT || 'https://ayyb2h6062.execute-api.us-east-1.amazonaws.com/dev',
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1'
      }
    }
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_S3_BUCKET || 'short-story-platform-dev-frontend-0grcwv1d',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1'
    }
  }
};

console.log('Final AWS Config:', awsConfig);

export default awsConfig;
